<template>
 <div  v-if="isUserLoggedIn">
    <v-app-bar 
      :dark="isDarkMode"
      :class="{ 'dark-mode-layout': isDarkMode, 'light-mode': !isDarkMode }"
      app
    >
      <v-tooltip :text="sidebarOpen ? 'Zavřít menu' : 'Otevřít menu'">
        <template v-slot:activator="{ props }">
          <v-app-bar-nav-icon v-bind="props" :style="{ color: isDarkMode ? 'white' : '' }" @click="toggleSidebar"></v-app-bar-nav-icon>
        </template>
      </v-tooltip>

      <v-tooltip text="Změnit pozadí">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" @click="toggleDarkMode" :style="{ color: isDarkMode ? 'white' : '' }">
            <v-icon :class="{ 'white--text': isDarkMode, 'black--text': !isDarkMode }">
              {{ isDarkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
            </v-icon>
          </v-btn>
        </template>
      </v-tooltip>
      <v-btn @click="logout" :style="{ color: isDarkMode ? 'white' : '' }">
        Odhlásit se
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      expand-on-hover
      rail
      :dark="isDarkMode"
      :class="{ 'dark-mode-layout': isDarkMode, 'light-mode': !isDarkMode }"
      v-model="sidebarOpen"
      :permanent="isSidebarOpenOnLargeDevices"
    >
      <v-list>
        <v-list-item
          :style="{ color: isDarkMode ? 'white' : '' }"
          prepend-icon="mdi-account"
          :subtitle="userData.email"
          :title="userData.displayName"
        ></v-list-item>
      </v-list>

      <v-divider :style="{ color: isDarkMode ? 'white' : '' }"></v-divider>

      <v-list density="compact" nav>
        <v-list-item
          :style="{ color: isDarkMode ? 'white' : '' }"
          to="/nastenka"
          prepend-icon="mdi-bulletin-board"
          title="Nástěnka"
        ></v-list-item>
  <v-list-item
    v-if="isAdmin === '1'"
    :style="{ color: isDarkMode ? 'white' : '' }"
    to="/dotaznik"
    prepend-icon="mdi-file-document-edit-outline"
    title="Dotazník"
  ></v-list-item>

  <v-list-item
  v-if="isAdmin === '1'"
  :style="{ color: isDarkMode ? 'white' : '' }"
  to="/fields"
  prepend-icon="mdi-form-select"
  title="Správa formulářů"
></v-list-item>

   <v-list-item
    v-if="isAdmin === '1'"
    :style="{ color: isDarkMode ? 'white' : '' }"
    to="/uzivatele"
    prepend-icon="mdi mdi-account-group"
    title="Uživatelé"
  ></v-list-item>


    <v-list-item
    v-if="isAdmin === '1'"
    :style="{ color: isDarkMode ? 'white' : '' }"
    to="/nastroje"
    prepend-icon="mdi mdi-tools"
    title="Nástroje"
  ></v-list-item>


      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    isDarkMode: {
      type: Boolean,
      required: true,
    },
  },
  
  data() {
    return {
      sidebarOpen: true,
      isSidebarOpenOnLargeDevices: true,
      isDarkMode: false,
      userData: {
        email: '',
        displayName: ''
      },
          isAdmin: localStorage.getItem('is_admin'),

    };
  },
  mounted() {
    
    const savedDarkMode = localStorage.getItem('isDarkMode');
    if (savedDarkMode) {
      this.isDarkMode = JSON.parse(savedDarkMode);
      this.$emit('dark-mode-changed', this.isDarkMode);
    }
    this.loadUserData();
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode;
      localStorage.setItem('isDarkMode', JSON.stringify(this.isDarkMode));
      this.$emit('dark-mode-changed', this.isDarkMode);
    },
    loadUserData() {
      const email = localStorage.getItem("user_email");
      const displayName = localStorage.getItem("user_displayName");
      const uid = localStorage.getItem("user_uid");
      if (email && displayName && uid) {
        this.userData = {
          email: email,
          displayName: displayName,
          uid: uid,
        };
      }
    },
    logout() {
      localStorage.clear();

      window.location.href = '/prihlaseni';
    },
  },
  computed: {
    isUserLoggedIn() {
      return localStorage.getItem("user_uid") !== null;
    }
  }
};
</script>

<style scoped>
.dark-mode-layout .v-navigation-drawer {
  background-color: #333;
}

.light-mode .v-navigation-drawer {
  background-color: #fff;
}

.dark-mode-layout .v-app-bar {
  background-color: #333;
}

.light-mode .v-app-bar {
  background-color: #fff;
}
</style>
